export const AircraftUtilizationExcelHeader = [
  {
    header: "AC REG ID",
    key: "AC REG ID",
    width: 25,
  },
  {
    header: "CUSTOMER CODE",
    key: "CUSTOMER CODE",
  },
  {
    header: "FLIGHT CYCLE",
    key: "FLIGHT CYCLE",
  },
  {
    header: "FLIGHT HOUR",
    key: "FLIGHT HOUR",
  },
  {
    header: "FLIGHT MINUTE",
    key: "FLIGHT MINUTE",
  },
  {
    header: "PERIOD YEAR",
    key: "PERIOD YEAR",
  },
  {
    header: "PERIOD MONTH",
    key: "PERIOD MONTH",
  },
  {
    header: "CREATED BY",
    key: "CREATED BY",
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
];

export const AircraftUtilizationExcelName = "Aircraft Utilization List";
